import { Grid } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import SharedToast from "../../shared/SharedToast/SharedToast";
import LandingBanner from "../LandingBanner/LandingBanner";
import LandingCompanies from "../LandingCompanies/LandingCompanies";
import LandingFeaturedJobs from "../LandingFeaturedJobs/LandingFeaturedJobs";
import { DisclaimerText } from "./styles";

function PaidLandingPageContent({ initialBanner = null }) {
  return (
    <>
      <SharedToast />

      <LandingBanner initialBanner={initialBanner} />
      <Grid
        container
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: { lg: "0px", md: "0px" },
        }}
      >
        <LandingCompanies />
        <LandingFeaturedJobs />
        <DisclaimerText>
          <i>
            THIS IS AN EXPERIENTIAL CAMPAIGN CONNOR'S COLLECTIVE CREATED IN
            COLLABORATION WITH HIREDLY. IT DOES NOT ENCOURAGE JOB QUITTING NOR
            GUARANTEE JOB PLACEMENT.
            <br />
            ALL ROLES ARE SHORT-TERM EXPERIENCES CREATED AS A STEPPING STONE TO
            HELP INDIVIDUALS EXPLORE THEIR INTERESTS BEYOND THEIR CURRENT JOBS.
          </i>
          {/* 
          By submitting your application, you agree to{" "}
          <a href="/terms-and-conditions" target="_blank">
            Connor’s Collective Terms & Conditions
          </a> */}
        </DisclaimerText>
        {/* <LandingJobs /> */}
      </Grid>
    </>
  );
}

export default PaidLandingPageContent;
